import * as StyledComponents from './StyledComponents';

export const AllowedIPInputWithHelperText = ({
  helperLabel,
  children,
}: {
  helperLabel: string;
  children: React.ReactNode;
}): JSX.Element => {
  return (
    <StyledComponents.StyledInputContainer>
      {children}
      {helperLabel && (
      <StyledComponents.StyledHelperLabelContainer>
        <StyledComponents.StyledHelperLabel>
          {helperLabel}
        </StyledComponents.StyledHelperLabel>
      </StyledComponents.StyledHelperLabelContainer>
      )}
    </StyledComponents.StyledInputContainer>
  );
};

